import React, { useEffect, useState } from "react";
import axiosInstance from "../../services/auth";
import "./Dashboard.css";
import { useCombinedContext } from "../../context/CombinedContext";
import { toast } from "react-toastify";

const DashboardList = () => {
  const [loading, setLoading] = useState(false);
    const authData =
    JSON.parse(localStorage.getItem("authData")) ||
    JSON.parse(sessionStorage.getItem("authData"));
 const userRole = authData.role;
  const [dashboardData, setDashboardData] = useState({
    totalAmount: 0,
    totalInvoices: 0,
    totalCompanies: 0,
    totalLocations: 0,
    godownTYStocks: [],
    godownBBStocks: [],
    godownTYMinStocks: [],
    godownBBMinStocks: [],
  });

  const { selectedCompany } = useCombinedContext();
  const companyId = selectedCompany?._id;

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/dashboard/${companyId}`);
      setDashboardData(response.data.data);
    } catch (error) {
      toast.error("Error fetching dashboard data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyId) {
      fetchDashboardData();
    }
  }, [companyId]);

  const {
    totalAmount,
    totalInvoices,
    totalLocations,
    godownTYMinStocks = dashboardData.godownTYStocks || [],
    godownBBMinStocks = dashboardData.godownBBStocks || [],
  } = dashboardData;

  const renderStockTable = (title, stockData) => (
    <div className="headStyle mt-4">
      <h5 className="mb-3 text-center">{title}</h5>
      <div className="my-3 rounded">
        <table className="table table-bordered table-responsive">
          <thead className="t_head">
            <tr className="text-center align-middle">
              <th className="align-middle">Sl No</th>
              <th className="align-middle">Stock No</th>
              <th className="align-middle">Name</th>
              <th className="align-middle">Description</th>
              <th className="align-middle">Quantity</th>
            </tr>
          </thead>
          <tbody>
            {stockData && stockData.length > 0 ? (
              stockData.map((item, index) => (
                <tr key={item.stockNo || index}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{item.stockNo}</td>
                  <td className="text-center">{item.name}</td>
                  <td className="text-center">{item.description || "N/A"}</td>
                  <td className="text-center">
                    <span
                      className={
                        item.quantity <= 5
                          ? "text-danger fw-bold"
                          : "text-warning fw-bold"
                      }
                    >
                      {item.quantity}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">
                  <div className="d-flex justify-content-center m-1">
                    <h6>No Stock Data Found</h6>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-content-center m-3"
          style={{ height: "60vh" }}
        >
          <div className="spinner"></div>
        </div>
      ) : ( 
        <div>
          <div className="container mt-4">
           {["admin", "superadmin"].includes(userRole) && (  <div className="row g-4 d-flex justify-content-center">
              {/* Total Amount Card */}
              <div className="col-md-6 col-lg-3">
                <div className="card text-white bg-gradient-primary shadow h-100">
                  <div className="card-body d-flex align-items-center justify-content-between">
                    <div>
                      <h5 className="card-title">Total Amount</h5>
                      <p className="card-text fs-4">
                        $ {totalAmount.toLocaleString()}
                      </p>
                    </div>
                    <i className="bi bi-currency-dollar display-4 opacity-75 fs-1"></i>
                  </div>
                </div>
              </div>

              {/* Total Invoices Card */}
              <div className="col-md-6 col-lg-3">
                <div className="card text-white bg-gradient-success shadow h-100">
                  <div className="card-body d-flex align-items-center justify-content-between">
                    <div>
                      <h5 className="card-title">Total Invoices</h5>
                      <p className="card-text fs-4">{totalInvoices}</p>
                    </div>
                    <i className="bi bi-file-earmark-text display-4 opacity-75 fs-1"></i>
                  </div>
                </div>
              </div>

              {/* Total Locations Card */}
              <div className="col-md-6 col-lg-3">
                <div className="card text-white bg-gradient-danger shadow h-100">
                  <div className="card-body d-flex align-items-center justify-content-between">
                    <div>
                      <h5 className="card-title">Total Locations</h5>
                      <p className="card-text fs-4">{totalLocations}</p>
                    </div>
                    <i className="bi bi-geo-alt-fill display-4 opacity-75 fs-1"></i>
                  </div>
                </div>
              </div>
            </div>
)}
            {/* Minimum (low) Stock Tables for Godown TY (Godown A) */}
            <div className="">
              {renderStockTable(
                "Minimum Stock - Godown TY (Godown A)",
                godownTYMinStocks
              )}
            </div>

            {/* Minimum (low) Stock Tables for Godown BB (Godown B) */}
            <div className="">
              {renderStockTable(
                "Minimum Stock - Godown BB (Godown B)",
                godownBBMinStocks
              )}
            </div>
          </div>
        
        </div>
      )}
    </>
  );
};

export default DashboardList;
